export const STAFF_CODE_ENDPOINT = "/auth/staff-send-code";
export const ADMIN_CODE_ENDPOINT = "/auth/admin-send-code";

export function codeSendEndpointForLoginResult(result = {}) {
  return result.requires_admin_verify ? ADMIN_CODE_ENDPOINT : STAFF_CODE_ENDPOINT;
}
